<template>
  <el-menu
    :default-active="activeIndex"
    mode="horizontal"
    background-color="#fff"
    text-color="#333"
    active-text-color="#409eff"
    router
  >
    <el-menu-item index="">
      <img src="@/assets/logo.png" class="logo">
    </el-menu-item>
    <el-menu-item index="/">首页</el-menu-item>
    <el-menu-item index="/Products">产品信息</el-menu-item>
    <el-menu-item index="/about">关于我们</el-menu-item>
    <el-menu-item index="/contact">联系我们</el-menu-item>
  </el-menu>
</template>
<script>
  export default {
    name: 'navBar',
    data() {
      return {
        activeIndex: '/'
      }
    }
  }
</script>
<style scoped>
.logo {
  height: 40px;
  margin-right: 30px;
}
.el-menu {
  padding: 0 10%;
}
</style>